<template>
  <div v-show="isActive" v-if="isActive">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Tab',
  props: {
    name: { required: true },
    selected: { default: false },
    empty: { default: false }
  },
  data () {
    return {
      isActive: false
    }
  },
  computed: {
    href () {
      return this.name ? '#' + this.name.toLowerCase().replace(/ /g, '-') : ''
    }
  },
  watch: {
    selected (newVal, oldVal) {
      if (newVal) {
        this.$emit('onTabSelected')
      }
    }
  },
  mounted () {
    this.isActive = this.selected
  }
}
</script>
